(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.PolyCircle = (function(superClass) {
    extend(PolyCircle, superClass);

    function PolyCircle() {
      return PolyCircle.__super__.constructor.apply(this, arguments);
    }

    PolyCircle.prototype.options = {
      polyOptions: {},
      nodes: 16
    };

    PolyCircle.prototype.initialize = function(center, radius, options) {
      L.setOptions(this, options);
      this.setCenter(center);
      return this.setRadius(radius);
    };

    PolyCircle.prototype.setCenter = function(center) {
      this._center = center;
      this.LATCONV = this._getLatConversion();
      this.LNGCONV = this._getLngConversion();
      if (this._poly != null) {
        return this.makePoly();
      }
    };

    PolyCircle.prototype.setRadius = function(radius) {
      this._radius = radius;
      if (this._poly != null) {
        return this.makePoly();
      }
    };

    PolyCircle.prototype.makePoly = function() {
      var i, j, points, ref, step;
      step = parseInt(360 / this.options.nodes);
      points = [];
      for (i = j = 0, ref = step; j <= 360; i = j += ref) {
        points.push(this._makePoint(i));
      }
      if (this._poly == null) {
        this._poly = new L.Polygon(points, this.options.polyOptions);
      } else {
        this._poly.setLatLngs(points);
      }
      return this._poly;
    };

    PolyCircle.prototype.getPoly = function() {
      if (this._poly != null) {
        return this._poly;
      } else {
        return this.makePoly();
      }
    };

    PolyCircle.prototype.onAdd = function(map) {
      var poly;
      poly = this.getPoly();
      return poly.onAdd(map);
    };

    PolyCircle.prototype.onRemove = function(map) {
      var poly;
      poly = this.getPoly();
      return poly.onRemove(map);
    };

    PolyCircle.prototype.toGeoJSON = function() {
      var poly;
      poly = this.getPoly();
      return poly.toGeoJSON();
    };

    PolyCircle.prototype._makePoint = function(angle) {
      var lat, lng;
      lat = this._center.lat + (this._radius / this.LATCONV * Math.cos(angle * (Math.PI / 180)));
      lng = this._center.lng + (this._radius / this.LNGCONV * Math.sin(angle * (Math.PI / 180)));
      return new L.LatLng(lat, lng);
    };

    PolyCircle.prototype._getLatConversion = function() {
      return this._center.distanceTo(new L.LatLng(this._center.lat + 0.1, this._center.lng)) * 10;
    };

    PolyCircle.prototype._getLngConversion = function() {
      return this._center.distanceTo(new L.LatLng(this._center.lat, this._center.lng + 0.1)) * 10;
    };

    return PolyCircle;

  })(L.Path);

}).call(this);
